import React from 'react';
import styled, { css } from 'styled-components';
import { getFluidGatsbyImage } from '../../utils/gatsby-storyblok-image-fixed';
import LazyImage from '../lazy-image';
import { Link } from 'gatsby';

const ProductSliderProductCardContainer = styled(Link)<{
  $theme?: 'white' | 'grey';
}>`
  text-decoration: none;
  cursor: pointer;
  flex: 0 0 258px;
  min-width: 0;
  position: relative;
  background: ${({ $theme }) => ($theme === 'white' ? '#F8F8F8' : '#fff')};
  border-radius: var(--Radius-Radius-3, 16px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 8px 8px 24px 8px;
  text-decoration: none;
  cursor: pointer;
  margin-right: 20px;
  aspect-ratio: 129 / 186;
  gap: 20px;
`;

const ProductThumbnailContainer = styled.span<{
  $theme?: 'white' | 'grey';
  $hasThumbnail?: boolean;
}>`
  height: calc(258px - 16px);
  width: calc(258px - 16px);
  overflow: hidden;
  position: relative;
  user-select: none;
  ${({ $hasThumbnail }) =>
    !$hasThumbnail &&
    css<{ $theme?: 'white' | 'grey' }>`
      background: ${({ $theme }) => ($theme === 'white' ? '#fff' : '#F8F8F8')};
    `}
`;

const ProductTitleContainer = styled.span<{ $hasProductName?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  justify-content: center;
  ${({ $hasProductName }) =>
    !$hasProductName &&
    css`
      justify-content: space-between;
    `}
`;

const ProductTitle = styled.span<{ $hasProductName?: boolean }>`
  text-decoration: none;
  color: var(--Foreground-fg-primary, #111);
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 160%;
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: balance;
  user-select: none;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  ${({ $hasProductName }) =>
    !$hasProductName &&
    css`
      vertical-align: top;
      height: 50px;
    `}
`;

const ProductButton = styled.span`
  appearance: none;
  text-decoration: none;
  color: var(--Foreground-fg-interactive, #813dff);
  font-family: var(--font-mulish);
  text-align: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 800;
  line-height: 140%;
  user-select: none;
`;

export default function ProductSliderProductCard({
  product,
  theme
}: {
  product: any;
  theme?: 'white' | 'grey';
}) {
  return (
    <ProductSliderProductCardContainer
      $theme={theme}
      to={`/${product?.full_slug}`}
    >
      <ProductThumbnailContainer
        $theme={theme}
        $hasThumbnail={product?.content?.productThumbnail}
      >
        {product?.content?.productThumbnail && (
          <LazyImage
            fluid={getFluidGatsbyImage(product?.content?.productThumbnail)}
            width="100%"
            height="100%"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              aspectRatio: '1/1',
              backgroundColor: 'transparent'
            }}
          />
        )}
      </ProductThumbnailContainer>
      <ProductTitleContainer $hasProductName={product?.content?.productName}>
        <ProductTitle $hasProductName={product?.content?.productName}>
          {product?.content?.productName ?? 'Product Name'}
        </ProductTitle>
        <ProductButton>View</ProductButton>
      </ProductTitleContainer>
    </ProductSliderProductCardContainer>
  );
}
